import { useMemo } from 'react';

import { TerritoryDataObjectsService } from 'services';
import { StringifiedUUID } from 'types';
import { TerritoryDataObject } from 'types/tqModelTree';

export type AllViewsTerritoryObjects = Record<StringifiedUUID | 'main', Record<StringifiedUUID, TerritoryDataObject>>;

type UseAllViewsTerritoryObjectsParams = {
  tqModelId: StringifiedUUID | undefined;
  enabled?: boolean;
};

export function useTerritoryObjectsFromAllViews({ tqModelId, enabled = true }: UseAllViewsTerritoryObjectsParams) {
  const { query, invalidateQuery } = TerritoryDataObjectsService.useGetAllViewsTerritoryDataObjectsQuery(tqModelId, {
    enabled: enabled && !!tqModelId,
  });

  // A map of all territories objects by territory view id
  const allTerritoriesObjectsMap = useMemo((): AllViewsTerritoryObjects => {
    if (!query.data) {
      return {};
    }

    const result: AllViewsTerritoryObjects = {};

    Object.entries(query.data).forEach(([viewId, territories]) => {
      const territoriesMap: Record<StringifiedUUID, TerritoryDataObject> = {};
      territories.forEach((territory) => {
        territoriesMap[territory.id] = territory;
      });
      result[viewId] = territoriesMap;
    });

    return result;
  }, [query.data]);

  return {
    allTerritoriesObjectsMap,
    allViewsTerritoryObjectsData: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    invalidateQuery,
  };
}
